module.exports = __webpack_public_path__ + "img/standard-viewer.722c14ee.svg";